export default __webpack_public_path__ + "static/media/spotAccomplices.376b677b.svg";